"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Tick = function Tick(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 30 30"
  }, props), _react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M2.286,14.605l4.138-4.144c1.971,1.974,3.24,3.247,5.218,5.23L22.825,4.508l4.16,4.169L11.666,23.992Z"
  }))));
};

var _default = Tick;
exports.default = _default;